import { Currency } from 'utils/Currency';
import { BloodVisionFaqs } from 'components/blood-vision/buy/FaqData';
import { generateProductSchema, generateFAQSchema, generateBreadcrumbSchema } from 'lib/seo/schema';
import { extractTextFromJSX } from 'utils/extractTextFromJSX';
import { getAssetUrl } from 'lib/config/assetUrls';

type JsonLdObject = Record<string, unknown>;

interface BloodVisionPricingSchemaParams {
  country: string;
  currency: Currency;
  isAvailable: boolean;
}

export const getBloodVisionPricingSchemas = ({
  country,
  currency: currencyParam,
  isAvailable,
}: BloodVisionPricingSchemaParams): JsonLdObject[] => {
  const codeLower = (country || 'us').toLowerCase();
  const codeUpper = codeLower.toUpperCase();

  const currency = (currencyParam || Currency.usd).toUpperCase();

  const basePrice = 99;

  const productSchema = generateProductSchema({
    name: 'Blood Vision',
    description: 'Decode the language of your blood with UltraTrace™',
    imageUrl: getAssetUrl('/web_v2/meta-assets/blood-vision-og.png'),
    brand: 'Ultrahuman',
    category: 'Health Testing',
    price: basePrice,
    currency,
    country: codeUpper,
    availability: isAvailable ? 'InStock' : 'OutOfStock',
    url: `https://www.ultrahuman.com/${codeLower}/blood-vision/buy`,
    rating: {
      ratingValue: 4.7,
      reviewCount: 1800,
    },
  });

  const faqItems = BloodVisionFaqs.map((faq) => ({
    question: faq.title,
    answer: extractTextFromJSX(faq.description) || 'Blood Vision FAQ answer',
  })).filter((item) => item.question.trim().length > 0);

  const faqSchema = generateFAQSchema(faqItems);

  const breadcrumbSchema = generateBreadcrumbSchema([
    {
      name: 'Home',
      url: 'https://www.ultrahuman.com',
    },
    {
      name: 'Blood Vision',
      url: 'https://www.ultrahuman.com/blood-vision',
    },
    {
      name: 'Buy Blood Vision',
      url: `https://www.ultrahuman.com/${codeLower}/blood-vision/buy`,
    },
  ]);

  return [productSchema, faqSchema, breadcrumbSchema];
};


